import * as React from 'react';
import { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import DonorManagerAPI from '../../../../services/donorAPI';
import { EmailPattern } from '../../../../utils/Utils';
import { withTranslation } from 'react-i18next';
import { getLanguageCode } from '../../../../utils/functionCommon';

const DonorSubmitComponent = (props: any) => {
  const { t } = props;
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event: any) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!EmailPattern.test(email)) {
      setIsValid(false);
    } else {
      setIsValid(true);
      setIsSubmitting(true);
      try {
        const res = await DonorManagerAPI.checkDonor({
          donorEmail: email,
          language: getLanguageCode(),
        });

        if (res && res.status === 200) {
          const delayTime = await delay(100);
          cancel(delayTime);
          setIsSubmited(true);
          setIsSubmitting(false);
        } else {
          setIsError(true);
        }
      } catch (error) {
        setIsSubmitting(false);
        setIsError(true);
        console.log(error);
      }
    }
  };

  const cancel = (timeoutId: any) => {
    clearTimeout(timeoutId);
  };

  function delay(time: any) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  return (
    <section className="no_color_change submit-section">
      {isSubmited ? (
        <div className="aw_container aw_text_block_module pt48 pb48 pt_mobile_32">
          <div className="aw_row no_row_gap">
            <div className="col_12">
              <h5 className="h5 dark aw_12col_text left">{t('submit_message_1')}</h5>
            </div>
          </div>
          <div className="aw_row no_row_gap left">
            <div className="col_12">
              <p>
                {t('submit_message_2')} <a href="#">{email}</a>
                {t('submit_message_3')}
              </p>
              <div className="col_12 left">
                <Button
                  className="aw_btn aw_primary aw_secondary_btn"
                  onClick={e => {
                    setIsSubmited(false);
                    setEmail('');
                  }}
                >
                  {t('different_email')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="aw_container aw_text_block_module pt48 pb48 pt_mobile_32">
          <div className="aw_row no_row_gap">
            <div className="col_12">
              <h5 className="h5 dark aw_12col_text left">{t('access_headline')}</h5>
            </div>
          </div>
          <div className="aw_row no_row_gap display-true left">
            <div className="col_12 sub-description">
              <p>{t('access_description')}</p>
              <div
                className=" "
                style={{
                  marginBottom: '5px',
                }}
              >
                <span className="p-input-icon-left w-100">
                  <InputText
                    type="email"
                    value={email}
                    onChange={handleChange}
                    placeholder={t('email_address')}
                    className={`${!isValid ? 'p-invalid' : ''} p-inputtext p-component email-input`}
                  />
                  {isError && (
                    <small id="username2-help" className="p-error block">
                      {t('error_message')}
                    </small>
                  )}
                  {!isValid && (
                    <small id="username2-help" className="p-error block">
                      {t('valid_message')}
                    </small>
                  )}
                </span>
              </div>
              <div className="col_12 left">
                <Button
                  label={t('send')}
                  iconPos="right"
                  disabled={!(email !== '') || isSubmitting}
                  className="btn-submit p-button-rounded"
                  //loading={isSubmitting}
                  onClick={e => handleSubmit(e)}
                  icon="pi pi-angle-right"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default withTranslation('language')(DonorSubmitComponent);
